import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ForgotPasswordService } from '../login/services/ForgotPassword.service';
@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.css']
})
export class InvoiceDetailsComponent implements OnInit {
  invoiceID:string="";
  element:HTMLElement;
  newWin;
  invoiceDetails: any;
  showOverlayInvoice: boolean = false;
  dataDisplay: boolean = false;
  constructor(private _route: ActivatedRoute, private router: Router, private _service: ForgotPasswordService) { }

  ngOnInit() {
    this.showOverlayInvoice = true;
    this._route.queryParams.subscribe(params => { this.invoiceID = params['Invoice_Id'] });
    //console.log("invoceid" + this.invoiceID);
    this.getInvoiceDetails();
  }

  getInvoiceDetails() {
    if (this.invoiceID !== undefined) {
      this._service.getInvoiceInfo(this.invoiceID).subscribe((data) => {
        this.invoiceDetails = data;
        if (this.invoiceDetails.id != null && this.invoiceDetails.id !== undefined && this.invoiceDetails.id != "") {
          this.dataDisplay = true;
        } else {
          this.dataDisplay = false;
        }
        this.showOverlayInvoice = false;
      });
    } else {
      this.dataDisplay = false;
      this.showOverlayInvoice = false;
    }
  }
  
  onPrint(){
   window.print();
}
}
